<template>
  <div class="containerbox">
    <div class="container">
      <div class="container-companytitle">
        <div class="container-title">
          <p class="container-titlea">公司介绍</p>
          <p class="container-titleb">Company Profile</p>
          <img class="container-titleimg" src="../../assets/pimgs/p_line.png" alt="" />
        </div>
      </div>
       <div class="home-img">
            <img class="container-icon" src="../../assets/pimgs/p_home_icon.png" alt="" />
       </div>
      <div class="container-company">
        <div class="home-companycot">
          <h4 class="container-texttitle">南京迪孚网络科技有限公司</h4>
          <P class="container-text">
            位于美丽城市南京，是从事医疗无线网络和物联网开发的企业，目前拥有多种产品，物联网输液系统、无线体温采集系统、婴儿系统、人员/资产定位系统，及无线网络等多种产品，为医院提供完善的服务，为国内多家医疗机构提供技术支持，获得了业内良好的口碑。
          </P>
        </div>
            <img class="container-img" src="../../assets/pimgs/p_company.png" alt="" />
      </div>

      <div class="container-companytitle container-margion" ref="solution">
        <div class="container-title">
          <p class="container-titlea">解决方案</p>
          <p class="container-titleb">Solutions</p>
          <img class="container-titleimg" src="../../assets/pimgs/p_line.png" alt="" />
        </div>
      </div>

      <ul class="container-solutions">
        <li @click="toWifiNetwork">
            <img src="../../assets/pimgs/p_home_wifi.png" alt="" />
            <p>WiFi网络解决方案</p>
        </li>
        <!-- <li @click="toTransfuse">
          <img src="../../assets/pimgs/p_home_infusion.png" alt="" />
          <p>输液监控系统</p>
        </li> -->
        <!-- <li @click="toTiwen">
            <img src="../../assets/pimgs/p_home_temper.png" alt="" >
            <p>无线体温采集系统</p>
        </li> -->
        <li @click="toBaby">
            <img src="../../assets/pimgs/p_home_baby.png" alt="" />
            <p>婴儿防盗系统</p>
        </li>
        <li @click="toAssets">
            <img src="../../assets/pimgs/p_home_orientation.png" alt="" />
            <p>人员/资产定位系统</p>
        </li>
      </ul>

      <div class="container-companytitle container-margion">
        <div class="container-title">
          <p class="container-titlea">我们的服务</p>
          <p class="container-titleb">Our Services</p>
          <img class="container-titleimg" src="../../assets/pimgs/p_line.png" alt="" />
        </div>
      </div>
    </div>
    <img class="home-serverimg" src="../../assets/pimgs/p_home_server.jpg" alt="" />
  </div>
</template>
<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$route.params.source === 'solution') {
        const solutionH = vm.$refs.solution.offsetTop
        console.log('productH', solutionH)
        window.scrollTo(0, solutionH - 100)
        // vm.$refs.product.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
    })
  },
  methods: {
    toWifiNetwork () {
      this.$router.push({ name: 'WifiNetwork' })
    },
    toTransfuse () {
      this.$router.push({ name: 'Transfuse' })
    },
    toTiwen () {
      this.$router.push({ name: 'Tiwen' })
    },
    toBaby () {
      this.$router.push({ name: 'Baby' })
    },
    toAssets () {
      this.$router.push({ name: 'Assets' })
    }

  }
}
</script>
<style scoped>
.containerbox{
  width: 100%;
  height: 100%;
  color: #5e5e5e;
  /* font-size: 16px; */
  font-size: 0.16rem;
  display: flex;
  justify-content: center;
  flex-direction:column;
  align-items: center;
}
.container{
 /* width: 680px; */
  width: 6.8rem;
}
.container-companytitle{
  margin: 0!important;
  width: 100%;
  /* height: 100px; */
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-title{
  /* width: 158px;
  height: 60px; */
  width: 1.8rem;
  height: 0.6rem;
  margin: 0!important;
  text-align: center;
}
.container-titlea{
  /* font-size: 24px;
  height: 31px;
  line-height: 31px; */
  font-size: 0.24rem;
  height: 0.31rem;
  line-height: 0.31rem;
}
.container-titleb{
  /* font-size: 10px;
  height: 15px;
  line-height: 15px; */
  font-size: 0.1rem;
  height: 0.15rem;
  line-height: 0.15rem;
  color: #bababa;
}
.container-titleimg{
    width: 100%;
}
.home-img{
    width: 100%;
    height: 0.6rem;
    display: flex;
    align-items: center;
}
.container-icon{
    width: 0.4rem;
    height: 0.4rem;
}
.container-company{
  display: flex;
  height: 2.8rem;
}
.container-margion{
  /* height: 170px; */
  height: 1.70rem;
}
.container-texttitle{
  color: #5a3de7;
  /* font-size: 16px;
  height: 30px;
  line-height: 30px;
  letter-spacing:2px; */
  font-size: 0.16rem;
  height: 0.3rem;
  line-height: 0.3rem;
  letter-spacing:0.02rem;
}
.container-text{
  color: #909090;
  text-indent:2em;
  /* font-size: 16px;
  height: 29px;
  line-height: 29px;
  letter-spacing:2px; */
  font-size: 0.16rem;
  height: 0.29rem;
  line-height: 0.29rem;
  /* letter-spacing:0.02rem; */
}
.home-companycot{
    width: 3.8rem;
    text-align: left;
}
.container-img{
    width: 3rem;
    height: 2.20rem;
}
.container-solutions{
  display: flex;
}
.container-solutions li{
  /* width: 140px; */
  text-align: center;
  width: 1.4rem;
  margin-left:0.2rem;
}
.container-solutions li:first-child{
  margin-left:0;
}
.container-solutions li img{
    height: 1.9rem;
    width: 1.2rem;
}
.container-solutions li p{
  /* height: 24px;
  line-height: 24px;
  font-size: 14px; */
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.14rem;
}
.home-serverimg{
    width: 7.5rem;
    height: 2.88rem;
}
</style>
